//Core
import {FC} from "react";
//Styles
import {Avatar, Typography} from "@mui/material";
import {NoAvatarBox, UserInfoBox, UserInfoLoginButton, UserInfoWalletText} from "./UserInfo.styles";
import {SideBarText} from "../../../SideBar.styles";
//Hooks
import {useUserInfo} from "./useUserInfo";
//Images
import {AvatarSvg} from "../../../img/avatar";


const UserInfo: FC = () => {
    const {user, userData, logout} = useUserInfo()
    return (
        <UserInfoBox>
            {(userData?.image || user?.picture)
                ? <Avatar src={userData?.image || user?.picture}/>
                : <NoAvatarBox><AvatarSvg/></NoAvatarBox>
            }
            <SideBarText>{userData?.name ?? ''}</SideBarText>
            <UserInfoWalletText>{userData?.wallet ?? ''}</UserInfoWalletText>
            <UserInfoLoginButton onClick={logout}>
                <Typography variant={'body2'}>
                    {'Logout'}
                </Typography>
            </UserInfoLoginButton>
        </UserInfoBox>
    )
}

export default UserInfo